export default function copyToClipboard() {
  const copyIcons = document.querySelectorAll(".reservation-number .number .copy-icon");

  copyIcons.forEach((copyIcon) => {
    const parentElement = copyIcon.closest('.number');
    const number = parentElement.querySelector("span").innerText;
    const successIcon = parentElement.querySelector(".success-icon");

    parentElement.addEventListener("click", (e) => {
      e.preventDefault();

      navigator.clipboard.writeText(number).then(() => {
        // Add 'hidden' class to copy icon and remove it from success icon
        copyIcon.classList.add('hidden');
        successIcon.classList.remove('hidden');

        // Hide the success icon after 3 seconds and show the copy icon again
        setTimeout(() => {
          successIcon.classList.add('hidden');
          copyIcon.classList.remove('hidden');
        }, 3000);
      }).catch(err => {
        console.error('Failed to copy text: ', err);
      });
    });
  });
}
